<template>
  <div class="staticBg">
    <v-container fluid class="linear-top">
      <v-layout row wrap text-xs-center>
         <v-flex xs12 md8 offset-md2>
          <v-layout row wrap text-xs-center class="main-title">
            <v-flex xs12 md12>
              <div class="subtitle">{{$t('text_disfruta')}}</div>
              <!-- <div class="subtitle2">¡Totalmente gratis! Solo registrándote con tu correo. Escribe tu correo para crear tú cuenta.</div> -->
              <div class="input-search-wrapper">
                <input type=email class="input-search" v-model="email" :placeholder="$t('email')">
                <v-btn class="input-search-btn" color="primary" @click="entrar">{{$t('entrar')}}</v-btn>
              <div class="subtitle3">{{$t('text_total_free')}}</div>

              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>


    <div class="devices" style="background: black">
      <div class="container mx-auto px-4 py-20">
        <v-flex>
          <v-layout row wrap text-xs-center>
            <img :src="splash" alt="Microcanales" id="logo" style="
              width: 100%;
              height: 100%;
              max-width: 699px;
              position: relative;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
              background: black;
              margin-top: 10px;">
            <diV style="width: 100%; text-align: center;">
            <v-btn color=primary to="/home" style="margin-top:40px;transform:scale(1.2); transform-origin: center">{{$t('ver_catalogo')}}</v-btn>
            </diV>
          </v-layout>
        </v-flex>
      </div>
    </div>
    <div class="devices">
      <div class="container mx-auto px-4 py-20">
        <h2 class="Montserrat m-8 py-8">{{$t('text_disfruta')}}</h2>
        <img width="100px" class="desktop-img" src="data:image/svg+xml;base64,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">
        <h3 class="mt-8 footer-text">{{$t('text_where')}}</h3>

      </div>
      <v-flex xs12>
        <v-layout row wrap text-xs-center>
          <v-flex xs12 sm3 md2 lg2 offset-sm3 offset-md4 offset-md4>
            <a target="blank" :href="iosUrl">
              <img class="imgapp" :src="iosImage">
            </a>
          </v-flex>
          <v-flex xs12 sm3 md2 lg2>
            <a target="blank" :href="androidUrl">
              <img class="imgapp" :src="androidImage">
            </a>
          </v-flex>
        </v-layout>
      </v-flex>
    </div>

    <footer class="footer">
      <v-flex xs12>
        <v-layout row wrap text-xs-center>
          <v-flex xs12 md3><span class="copy">AMC Mikro © 2021 - AMC</span></v-flex>
          <v-flex xs12 md6>
            <ul class="text-left inline-block">
              <!-- <li class="inline-block pr-4 mb-2"><a href="https://microcanales-cne-df069.appspot.com.storage.googleapis.com/cookie.html" target="_blank" class="link">
                {{$t('navMenu.cookies')}}
                </a>
              </li> -->
                  <li class="inline-block pr-4 mb-2"><a :href="privacy" target="_blank" class="link">
                {{$t('navMenu.privacy')}}
              </a></li>
                  <li class="inline-block pr-4 mb-2"><a :href="terms" class="link" target="_blank">
                {{$t('navMenu.terms')}}
              </a></li>
            </ul>
          </v-flex>
          <v-flex xs12 md3>
            <div class="flex-1 flex justify-end items-center"><a target="_blank" :href="instagram" class="px-4"><v-icon color="primary">$vuetify.icons.instagram</v-icon></a> <a target="_blank" :href="facebook" class="px-4"><v-icon color="primary">$vuetify.icons.facebook</v-icon></a></div>
          </v-flex>
        </v-layout>
      </v-flex>
    </footer>

  </div>
</template>

<script>
  import { auth } from '@/config'
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import { storage, brightcove } from '@/config'

  const configSplash = {
    'microcanales-cne-df069': '/splash_logos_hungary.png',
    'amc-mikro-cz': '/splash_logos_cz.png'
  }
  const fid = storage._delegate._bucket.bucket.split('.')[0]
  const siteId = fid === 'microcanales-cne-df069' ? 'hun' : 'cz'

  export default {
    data() {
      return {
        email: '',
        iosUrl: brightcove[siteId].iosUrl,
        iosImage: brightcove[siteId].iosImage,
        androidUrl: brightcove[siteId].androidUrl,
        androidImage: brightcove[siteId].androidImage,
        facebook: brightcove[siteId].facebook,
        instagram: brightcove[siteId].instagram,
        terms: brightcove[siteId].terms,
        privacy: brightcove[siteId].privacy,
        about: brightcove[siteId].about
      }
    },
    computed: {
      splash() {
        return configSplash[fid]
      }
    },
    methods: {
      ...mapMutations(['setEmail']),
      async checkEmail(email) {
        const res = await auth.fetchSignInMethodsForEmail(email)
        return (res.length && !!res.find(i => i === 'password'))
      },
      async entrar() {
        this.setEmail(this.email)
        const check = await this.checkEmail(this.email)
        const signupOrSignin = check ? '/signin' : '/signup'
        this.$router.push({path: signupOrSignin})
      }
    },
    created() {
    }
  }
</script>

<style scoped>
  .p-custom {
    padding: 5%;
  }
  /* latin */
  @font-face {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Raleway Light'), local('Raleway-Light'), url(https://fonts.gstatic.com/s/raleway/v14/1Ptrg8zYS_SKggPNwIYqWqZPANqczVs.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  .main-title {
    padding-top: 25px;
  }
  .linear-top {
    background: linear-gradient(180deg, rgb(0, 0, 0) 0%, rgba(0,0,0,0.828693790149893) 31%, rgba(0,212,255,0) 100%);
  }
  .flex-direction-reverse {
    flex-direction: row-reverse;
  }
  footer, .footer {
    background: #fdfdfd;
    padding-top: 50px;
    padding-bottom: 50px;

  }
  .input-search-wrapper {
    margin-top: 40px;
  }
  .input-search {
    background: white;
    height: 36px;
    max-width: 400px;
    min-width: 200px;
    width: 68%;
    margin: 0;
    padding: 0;
    padding-bottom: 3px;
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
    color: black;
    text-indent: 20px;
    font-family: Montserrat;
  }
  .input-search-btn {
    padding: 0;
    margin: 0;
  }
  .copy {
    color: black;
  }
  .inline-block {
    display: inline-block;
  }
  .text-left {
    text-align: left;
  }
  .imgapp {
    height: 50px;
  }
  .footer-text {
    font-family: Montserrat;
    text-align: center;
    font-weight: 100;
    padding-top: 30px;
    padding-bottom: 30px;
    font-size: 25px;

  }
  .staticBg {
    background-image: url(/bg.png);
    background-repeat: repeat;
    background-size: contain;
    z-index: 0;
    color: white;
  }
/*  .main-box {
    background: #222;
    background: url(/sanvalentin.jpg);
    background-position: left bottom;
  }*/
  .logo {
    width: 160px;
    height: auto;
    margin-bottom: 1em;
    margin-top: 2em;
  }
  .subtitle {
    font-family: Montserrat;
    font-size: 3.5vw;
    font-weight: 900;
    /*letter-spacing: 2.3px;*/
  }
  .subtitle-red {
    color: #da2d41;
  }
  .subtitle2 {
    font-family: Montserrat;
    font-size: 1.5vw;
    font-weight: 400;
  }
  .subtitle3 {
    font-family: Montserrat;
    font-size: 1.5vw;
    font-weight: 400;
    margin-top: 15px;
  }
  .subtitle4 {
    font-family: Montserrat;
    font-size: 1.7rem;
    letter-spacing: 0.3px;
  }
  .subtitle5 {
    font-family: Montserrat;
    font-size: 1.7rem;
    letter-spacing: 1.2px;
  }


  .logo {
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease;
  }

  .fixed-header .logo {
    width: 104px;
    height: 62px;
    margin-left: 2em;
    margin-bottom: 0em;
  }

  .min80 {
    min-height: 80vh;
  }

  @media (max-width: 768px) {
    .subtitle {
      font-size: 5vw;
    }
    .subtitle2 {
      font-size: 2.5vw;
    }
  }
  @media (max-width: 600px) {
    .logo {
      display: none;
    }
    .subtitle3 {
      font-size: 2.5vw;
    }
/*    .subtitle {
      padding-top: 30px;
    }*/
    .subtitle-red {
      display: block;
    }
    .fixed-header .logo {
      width: 140px;
      margin-left: 1em;
    }
  }

  @media (max-width: 400px) {
    .flex-direction-reverse {
      margin-top: 60px;
    }
    .subtitle {
      font-size: 6vw;
    }
    .subtitle2, .subtitle3 {
      font-size: 4vw;
    }
  }

  @media (max-width: 320px) {
    .fixed-header .logo {
      width: 122px;
      margin-left: 0.8em;
    }
  }

</style>
<style scoped>
  ul {
    list-style: none;
    padding: 0; }

  .link,
  i {
    color: #DA2C42;
    font-weight: bold; }

  .btn {
    background-color: #fff;
    color: #000; }

  .btn-accent {
    background-color: #DA2C42;
    color: #fff; }

  #cta {
    text-decoration: none; }

  .container video {
    cursor: pointer; }

  #goliathus {
    position: fixed;
    left: 0;
    top: 60vh;
    z-index: -1;
    -webkit-transition: all 0.1s;
    transition: all 0.1s; }

  @media (max-width: 375px) {
      #goliathus {
        display: none; } }

  @media (min-width: 1400px) {
      #goliathus {
        top: 45vh; } }

  @media (max-width: 1024px) {
      #goliathus {
        top: 70vh; } }

  @media (max-width: 768px) {
      #goliathus {
        top: 62vh; } }

  .bg {
    height: 80vh; }

  @media (max-height: 375px) {
      .bg {
        height: auto; } }

  @media (max-width: 320px) {
      .bg {
        height: 89vh; } }

  @media (min-width: 1024px) {
      .bg {
        height: 90vh; } }

  .pin-t-2 {
    top: 2em; }

  .topic-bg {
    background-color: #fff;
    color: #000;
    background-repeat: no-repeat;
    background-size: cover;
    height: -webkit-fill-available;
    height: -moz-available;
    height: stretch;
    height: 640px;
    border: 2px solid #000; }

  @media (min-width: 1024px) {
      .topic-bg {
        height: 560px; } }

  @media (min-width: 1920px) {
      .topic-bg {
        height: 748px; } }

  .topic-bg h3.Montserrat{
    font-size: 2.8em; }

  @media (min-width: 1024px) {
      .topic-bg h3.Montserrat{
        font-size: 2em; } }

  .Montserrat{
    font-family: 'Montserrat'; }

  h2.Montserrat{
    font-weight: bold;
    font-size: 3em;
    font-family: 'Montserrat';
    text-transform: uppercase; }

    h2.Montserrat{
        font-weight: 700;
        font-size: 3em;
        text-transform: uppercase;
        width: 100%;
        display: inline-block;
        padding: 30px 40px;
        text-align: center;
    }
  .estrenos {
    background-image: url(/landing/estrenos.378ff3d.jpg);
    background-repeat: no-repeat;
    background-position: bottom; }

  .festivales {
    background-image: url(/landing/festivales.7821197.jpg);
    background-repeat: no-repeat;
    background-position: bottom; }

  .generos {
    background-image: url(/landing/generos.7780b0a.jpg);
    background-repeat: no-repeat;
    background-position: bottom; }

  .precios {
    background-image: url(/landing/precios.09627dc.jpg);
    background-repeat: no-repeat;
    background-position: bottom; }

  .header {
    font-size: 2em;
    font-weight: bold; }

  ul.topics li,
  ul.topics {
    display: inline-block; }

  .topics {
    color: #DA2C42;
    font-size: 1.8em;
    margin-top: 0.5em;
    line-height: 1.2em;
    font-weight: 600; }

  @media (min-width: 1024px) {
      .topics {
        font-size: 1.2em; } }

  .s_text {
    color: #DA2C42;
    margin-top: 0.5em;
    line-height: 1.2em;
    font-weight: 600;
    font-size: 1em; }

  #promo-video {
    width: 80%; }

  @media (min-width: 400px) {
      #promo-video {
        width: 90%; } }

  .bg-video {
    color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #000;
    position: relative;
    overflow: hidden; }

  @media (max-width: 600px) {
      .bg-video h2.Montserrat.py-32 {
        padding-top: 1rem;
        padding-bottom: 1rem;
        margin: 50px auto;
        font-size: 2.2rem;
      }
    }

  .bg-video h3 {
    display: inline-block;
    position: relative;
    width: 100%; }

  #bg-video {
    overflow: hidden;
    opacity: .15;
    min-height: 100%;
    min-width: 100%;
    background-size: cover;
    z-index: 2;
    max-width: inherit;
    position: absolute;
    top: -50%;
    overflow: hidden;
    opacity: 0.15;
    pointer-events: none;
    right: 0; }

  #logo {
    width: 600px;
    height: 150px;
    margin-bottom: 6em; }

  @media (max-width: 600px) {
      #logo {
        width: 290px;
        margin-bottom: 2em; } }

  @media (max-width: 375px) {
      #logo {
        width: 240px;
        height: 100px; } }

  .text-boxing {
    padding: 0 8em; }

  @media (max-width: 600px) {
      .text-boxing {
        padding: 0 2em; } }

  @media (max-width: 350px) {
      .text-boxing {
        padding: 0 1em; }
        .text-boxing h1.header-white {
          font-size: 2em; }
        .text-boxing h2.header-white {
          font-size: 1em; } }

  @media (max-height: 375px) {
      .text-boxing {
        padding: 0 2em; } }

  @media (max-width: 600px) {
    #cta {
      padding-left: 3rem;
      padding-right: 3rem; } }

  #cta,
  #logo {
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease; }

  .header-white,
  .text_white {
    color: #fff; }

  h1.header-white {
    font-weight: bold;
    font-size: 2.8em;
    padding-bottom: 0.5em;
    font-family: 'Montserrat';
    text-transform: uppercase; }

  @media (max-width: 400px) {
      h1.header-white {
        font-size: 2.2em; } }

  h2.header {
    font-family: 'Montserrat';
    text-transform: uppercase;
    font-size: 2.8em; }

  h2.header-white {
    padding-bottom: 2em;
    font-weight: lighter; }

  .sticky-header {
    position: -webkit-sticky;
    position: sticky; }

  @media (max-height: 375px) {
      .sticky-header {
        padding-top: 0rem;
        padding-bottom: 0rem; } }

  @media (min-width: 2560px) {
      .sticky-header {
        padding-top: 25vh;
        padding-bottom: 25vh; } }

  .fixed-header {
    position: fixed;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding-top: 1rem;
    padding-bottom: 8rem;
    background-image: url(/landing/bg_header.5471099.png);
    background-position-y: 40%;
    background-repeat: repeat;
    background-size: cover;
    width: 100%;
    z-index: 2; }

  .fixed-header .header-white {
      display: none; }

  .fixed-header .text_white {
      width: 80%;
      clear: both;
      position: fixed;
      top: 75px;
      text-align: end;
      padding: 0px 10px;
      font-size: 0.8em;
      right: 0;
      margin-right: 2em; }

  @media (max-width: 600px) {
        .fixed-header .text_white {
          margin-right: 1em; } }

  @media (max-width: 320px) {
        .fixed-header .text_white {
          margin-right: 0.8em; } }

  .fixed-header #logo {
      width: 104px;
      height: 62px;
      margin-left: 2em;
      margin-bottom: 0em; }

  @media (max-width: 600px) {
        .fixed-header #logo {
          width: 140px;
          margin-left: 1em; } }

  @media (max-width: 320px) {
        .fixed-header #logo {
          width: 122px;
          margin-left: 0.8em; } }

  .fixed-header #cta {
      padding-left: 1rem;
      padding-right: 1rem;
      margin-right: 2em; }

  .fixed-header #cta b {
        font-size: 0.8em; }

  @media (max-width: 600px) {
        .fixed-header #cta {
          line-height: 1em;
          margin-right: 1em; }
          .fixed-header #cta span {
            font-size: 0.75em; } }

  @media (max-width: 320px) {
        .fixed-header #cta {
          margin-right: 0.8em; }
          .fixed-header #cta b {
            font-size: 0.6em; } }

  @media (max-width: 600px) {
      .fixed-header {
        padding-top: 0.5rem; } }
        .devices {
          background-color: #fff;
          /*background-image: url(/landing/bg_header.5471099.png);*/
          background-position-y: -120px;
          background-repeat: no-repeat;
          color: black;
        }
        footer[data-v-6062e505] {
          background-color: #fdfdfd;
        }
        footer i[data-v-6062e505] {
          font-size: 2em;
        }
        #faqs h1[data-v-6062e505],
        #terms h1[data-v-6062e505],
        #faqs h3[data-v-6062e505],
        #terms h3[data-v-6062e505],
        #faqs p[data-v-6062e505],
        #terms p[data-v-6062e505] {
          margin: 1em 0em;
        }
        #faqs p[data-v-6062e505],
        #terms p[data-v-6062e505],
        #faqs li[data-v-6062e505],
        #terms li[data-v-6062e505] {
          font-family: 'Montserrat', sans-serif;
          line-height: 1.5;
          font-size: 14px;
        }
        #terms[data-v-6062e505],
        #faqs[data-v-6062e505] {
          margin-top: 6em;
          margin-bottom: 4em;
        }
        #faqs h1[data-v-6062e505],
        #terms h1[data-v-6062e505] {
          color: #da2c42;
          font-weight: 700;
          font-size: 30pt;
          font-family: 'Montserrat';
        }
        #faqs h3[data-v-6062e505],
        #terms h3[data-v-6062e505] {
          font-family: 'Montserrat';
        }
        #faqs a[data-v-6062e505],
        #terms a[data-v-6062e505] {
          color: #da2c42;
          font-weight: 700;
          text-decoration: none;
        }
        ul.list li[data-v-6062e505]{
          list-style-type: circle;
          margin-left: 40px;
        } 
.desktop-img {
  margin: auto calc(50% - 50px);
}

</style>
